
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import PiedrasCompactasSection from '../../components/feature/PiedrasCompactasSection';

export default function PiedrasCompactasPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <div className="bg-white min-h-screen flex items-center">
        <div className="w-full mx-auto text-center" style={{ padding: 'clamp(2rem, 4vh, 6rem) clamp(1rem, 3vw, 5rem)' }}>
          <h1 
            className="font-light text-gray-900" 
            style={{ 
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(2.5rem, 5vw, 7rem)',
              marginBottom: 'clamp(1rem, 2vh, 3rem)'
            }}
          >
            PIEDRA COMPACTA
          </h1>
          <p 
            className="text-gray-900 max-w-[1400px] mx-auto leading-relaxed" 
            style={{ 
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: 'clamp(1rem, 1.2vw, 2rem)',
              padding: '0 clamp(1rem, 2vw, 3rem)'
            }}
          >
            La piedra compacta natural es un material que combina a la perfección tecnologia y naturalidad. Compuesto por un 95% en piedra natural y un 5% en resinas minerales.
            <br /><br />
            Entre sus cualidades destacamos su gran resistencia y facilidad de limpieza.
          </p>
        </div>
      </div>

      <PiedrasCompactasSection />

      <Footer />
    </div>
  );
}
